// extracted by mini-css-extract-plugin
export default {"tableRow":"violationList_tableRow__t8BMP","tableCell":"violationList_tableCell__RAz6I"};